import debounce from 'lodash/debounce';
import store from '@/store';

const loadVariantPricing = debounce(function (productCode) {
  if (!productCode) {
    return;
  } else {
    const product = store.getters['productDetails/locallyVariantProduct'].variants.find(
      (variant) => variant.code === productCode
    );
    let productPricing = null;
    if (product) {
      productPricing = {
        retailerPrice: product.prices?.retailerPrice,
        consumerPrice: product.prices?.consumerPrice,
        appleLabels: product.prices?.appleLabels,
      };
    }
    const pricingData = {code: productCode, prices: productPricing};
    store.commit('productDetails/setProductPricing', pricingData);
  }
}, 10);

const loadModelPricing = function (model) {
  if (!model.prices) {
    return;
  } else {
    const productPricing = {
      retailerPrice: model.prices?.retailerPrice,
      consumerPrice: model.prices?.consumerPrice,
    };
    const pricingData = {code: model.code, prices: productPricing};
    store.commit('productDetails/setProductPricing', pricingData);
  }
};

export {loadVariantPricing, loadModelPricing};
